module.exports = __webpack_public_path__ + "static/media/img28.58f26b8f.jpg";